export default __webpack_public_path__ + "static/experience-bg-c54f7a3ba1d83941d0f9bf2096ed0c0d.png";